import type { AdminNotificationId } from "../../domain/types";

type NotificationLink =
  | { to: "/app/wallet/topup-queue" }
  | { to: "/app/wallet/refund-queue" }
  | {
      to: "/app/customers";
      search: {
        kycStatus: "PENDING";
        q?: string;
        limit: number;
        offset: number;
        sortField: "createdAt";
        sortOrder: "desc";
      };
    }
  | { to: "/app/orders" }
  | { to: "/app/inventory/lots" }
  | { to: "/app/inventory/purchase-orders" }
  | { to: "/app/inventory/transfers" };

export const NOTIFICATION_LINKS: Record<AdminNotificationId, NotificationLink> =
  {
    wallet_topup_queue: { to: "/app/wallet/topup-queue" },
    wallet_refund_queue: { to: "/app/wallet/refund-queue" },
    customers_kyc_pending: {
      to: "/app/customers",
      search: {
        kycStatus: "PENDING",
        limit: 20,
        offset: 0,
        sortField: "createdAt",
        sortOrder: "desc",
      },
    },
    orders_pending_confirmation: { to: "/app/orders" },
    inventory_near_expiry: { to: "/app/inventory/lots" },
    inventory_purchase_orders_submitted: {
      to: "/app/inventory/purchase-orders",
    },
    inventory_transfers_submitted: { to: "/app/inventory/transfers" },
  };

export function formatNotificationBadge(count: number): string {
  if (count > 99) return "99+";
  return String(count);
}
